import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';
import { ExteriorCornersNote } from './OptionGroupNotes';
import WhatIsThisDictionaryTermLink from '../../../WhatIsThisDictionaryTermLink';
import { SubHeaderWithInfoButton } from '../../../WhatIsThisDictionaryTermLink/styles';
import hidden from '../hidden/index';

const ChooseExteriorAnglesOptionGroup = ({ children, group }) =>
  children.length > 0 && (
    <div
      id="ChooseExteriorAngles"
      data-template="ChooseExteriorAnglesOptionGroup"
      className="card-content flex-wrap-dependent-options"
    >
      <SubHeaderWithInfoButton>
        <div className="row-header">
          <div className="row-header__title md:sui-flex">
            <div id={`Option_${children[0].props.option.id}`}>
              <Typography variant="h2" className="sui-border-none">
                Corner Roundness
              </Typography>
            </div>
            {group.hasDictionaryTerm && (
              <WhatIsThisDictionaryTermLink
                term={group.dictionaryTerm.term}
                header="Corner Roundness"
              />
            )}
          </div>
        </div>
      </SubHeaderWithInfoButton>
      <div className="subQuestion">
        <span>{`${'Choose how round you\'d like your exterior corners. '}`}</span>
        <ExteriorCornersNote />
      </div>
      <div className="flex-wrap-dependent-options dependent-options">{children}</div>
    </div>
  );

ChooseExteriorAnglesOptionGroup.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
  group: PropTypes.shape({
    hasDictionaryTerm: PropTypes.bool,
    dictionaryTerm: PropTypes.shape({
      term: PropTypes.string,
    }),
  }).isRequired,
};

export default ChooseExteriorAnglesOptionGroup;
